import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row gt-sm items-start full-height full-width grouper-body-container" }
const _hoisted_2 = { class: "col full-width full-height grouper-body-splitter-container" }
const _hoisted_3 = { key: 0 }

import { useGrouperStore } from 'stores/GrouperStore';
    import CodesPane from 'components/codes/CodesPane.vue';
    import ResourcesPane from 'components/resources/ResourcesPane.vue';
    import SearchPane from 'components/search/SearchPane.vue';
    import ReferencesPane from 'components/references/ReferencesPane.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'GrouperBodyFullscreen',
  setup(__props) {

    const noOfSplits = (
        (useGrouperStore().isCodesSelected ? 1 : 0) +
        (useGrouperStore().isSearchSelected ? 1 : 0) +
        (useGrouperStore().isReferencesSelected ? 1 : 0) +
        (useGrouperStore().isResourcesSelected ? 1 : 0)
    )

return (_ctx: any,_cache: any) => {
  const _component_q_slide_transition = _resolveComponent("q-slide-transition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_slide_transition, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (noOfSplits === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_unref(useGrouperStore)().isCodesSelected)
                  ? (_openBlock(), _createBlock(CodesPane, { key: 0 }))
                  : _createCommentVNode("", true),
                (_unref(useGrouperStore)().isResourcesSelected)
                  ? (_openBlock(), _createBlock(ResourcesPane, { key: 1 }))
                  : _createCommentVNode("", true),
                (_unref(useGrouperStore)().isSearchSelected)
                  ? (_openBlock(), _createBlock(SearchPane, { key: 2 }))
                  : _createCommentVNode("", true),
                (_unref(useGrouperStore)().isReferencesSelected)
                  ? (_openBlock(), _createBlock(ReferencesPane, { key: 3 }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})